<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2" i18n>Viewing Survey: {{ survey.survey_id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 800px">
    <h5 class="mb-0" i18n>General Information</h5>
    <hr />

    <div class="row mb-5">
      <div class="col">
        <div class="field-label" i18n>Name</div>
        <div>{{ survey.survey_name }}</div>
      </div>
      <div class="col">
        <div class="field-label" i18n>Type</div>
        <div>{{ survey.survey_type }}</div>
      </div>
    </div>

    <h5 class="mb-0" i18n>Questions</h5>
    <hr />

    <div *ngFor="let question of survey.questions; let qi = index">
      <nb-accordion class="mt-3">
        <nb-accordion-item>
          <nb-accordion-item-header class="d-flex align-items-center">
            <div class="flex-grow-1" i18n>Question {{ qi + 1 }}</div>
          </nb-accordion-item-header>
          <nb-accordion-item-body>
            <div class="d-flex mb-3">
              <nb-checkbox disabled [checked]="question.visible"></nb-checkbox>
              <div class="field-label ml-2" i18n>Visible</div>
            </div>

            <div class="row mb-5">
              <div class="col">
                <div class="field-label" i18n>Question ID</div>
                <div>{{ question.question_id }}</div>
                <div class="field-label mt-3" i18n>Question Name</div>
                <div>{{ question.question_name || '-' }}</div>
                <div class="field-label mt-3" i18n>Question Title ID</div>
                <div>{{ question.title_id || '-' }}</div>
                <div class="field-label mt-3" i18n>Question Image ID</div>
                <div>{{ question.image_id || '-' }}</div>
              </div>
              <div class="col">
                <div class="field-label" i18n>Question Type</div>
                <div>{{ question.question_type }}</div>
                <div class="field-label mt-3" i18n>Question Title Text</div>
                <div>{{ question.value || '-' }}</div>
                <div class="field-label mt-3" i18n>Question Subtitle ID</div>
                <div>{{ question.subtitle_id || '-' }}</div>
                <div class="field-label mt-3" i18n>Question Display Order</div>
                <div>{{ question.display_order || '-' }}</div>
              </div>
            </div>

            <h6 class="mb-0" i18n>Answers</h6>
            <hr />

            <div *ngFor="let answer of question.answers; let ai = index">
              <nb-accordion class="mt-3">
                <nb-accordion-item>
                  <nb-accordion-item-header class="d-flex align-items-center">
                    <div class="flex-grow-1" i18n>Answer {{ ai + 1 }}</div>
                  </nb-accordion-item-header>
                  <nb-accordion-item-body>
                    <div class="row mb-5">
                      <div class="col">
                        <div class="field-label" i18n>Answer ID</div>
                        <div>{{ answer.answer_id }}</div>
                        <div class="field-label mt-3" i18n>Answer Value</div>
                        <div>{{ answer.value || '-' }}</div>
                        <div class="field-label mt-3 d-flex">
                          <div i18n>Minimum Value</div>
                          <nb-icon
                            class="ml-2"
                            icon="info-outline"
                            nbTooltip="Minimum value when answer type is rating."
                            i18n-nbTooltip
                          ></nb-icon>
                        </div>
                        <div>{{ answer.min_value || '-' }}</div>
                        <div class="field-label mt-3" i18n>Minimum Value Description</div>
                        <div>{{ answer.min_value_text || '-' }}</div>
                        <div class="field-label mt-3" i18n>Minimum Value Description ID</div>
                        <div>{{ answer.min_value_text_id || '-' }}</div>
                        <div class="field-label mt-3" i18n>Answer Image ID</div>
                        <div>{{ answer.image_id || '-' }}</div>
                      </div>
                      <div class="col">
                        <div class="field-label" i18n>Answer Type</div>
                        <div>{{ answer.answer_type }}</div>
                        <div class="field-label mt-3" i18n>Answer Value ID</div>
                        <div>{{ answer.value_id || '-' }}</div>
                        <div class="field-label mt-3 d-flex">
                          <div i18n>Maximum Value</div>
                          <nb-icon
                            class="ml-2"
                            icon="info-outline"
                            nbTooltip="Maximum value when answer type is rating."
                            i18n-nbTooltip
                          ></nb-icon>
                        </div>
                        <div>{{ answer.max_value || '-' }}</div>
                        <div class="field-label mt-3" i18n>Maximum Value Description</div>
                        <div>{{ answer.max_value_text || '-' }}</div>
                        <div class="field-label mt-3" i18n>Maximum Value Description ID</div>
                        <div>{{ answer.max_value_text_id || '-' }}</div>
                      </div>
                    </div>

                    <h6 class="mb-0" i18n>Actions</h6>
                    <hr />

                    <div *ngFor="let action of answer.actions; let aci = index">
                      <nb-accordion class="mt-3">
                        <nb-accordion-item>
                          <nb-accordion-item-header class="d-flex align-items-center">
                            <div class="flex-grow-1" i18n>Action {{ aci + 1 }}</div>
                          </nb-accordion-item-header>
                          <nb-accordion-item-body>
                            <div class="row">
                              <div class="col">
                                <div class="field-label" i18n>Action Type</div>
                                <div>{{ action.action_type }}</div>
                              </div>
                              <div class="col">
                                <div class="field-label" i18n>Action Value</div>
                                <div>{{ action.action_value || '-' }}</div>
                              </div>
                            </div>

                            <div class="field-label mt-3" i18n>Action Payload</div>
                            <hr class="mt-2" />
                            <div class="field-label" i18n>URL</div>
                            <div>{{ action.action_payload.url || '-' }}</div>
                          </nb-accordion-item-body>
                        </nb-accordion-item>
                      </nb-accordion>
                    </div>
                  </nb-accordion-item-body>
                </nb-accordion-item>
              </nb-accordion>
            </div>
          </nb-accordion-item-body>
        </nb-accordion-item>
      </nb-accordion>
    </div>
  </nb-card-body>
</nb-card>
